import { Cuenta } from 'core/cuenta/models/Cuenta';
import { EstadoTransferencia } from 'core/cuenta/models/Transferencia';
import { SelectOption } from 'shared/form/models/SelectOption';

export class SearchTransfersRequest {
  cuentaOrigen: number;
  cuentaDestino: number;
  from: Date;
  to: Date;
  username: string;
  estado?: EstadoTransferencia;
  page: number;
  size: number;

  constructor(data?: {
    cuentaOrigen?: SelectOption<Cuenta>;
    cuentaDestino?: SelectOption<Cuenta>;
    dateFrom?: Date;
    dateTo?: Date;
    page?: number;
    size?: number;
    estado?: EstadoTransferencia | 'Todos';
    username?: string;
  }) {
    const safeData = data || {};
    // si no hay fechas de busqueda se realiza la busqueda de transferencias 1 año para atrás
    if (safeData.dateFrom) {
      this.setFromDate(safeData.dateFrom);
    } else {
      const aDate = new Date();
      aDate.setFullYear(aDate.getFullYear() - 1);
      this.setFromDate(aDate);
    }
    this.setToDate(safeData.dateTo || new Date());
    this.cuentaOrigen = safeData?.cuentaOrigen?.value?.numeroCuenta;
    this.cuentaDestino = safeData?.cuentaDestino?.value?.numeroCuenta;
    this.page = safeData?.page;
    this.size = safeData?.size;
    this.estado = safeData?.estado === 'Todos' ? null : safeData?.estado;
    this.username = safeData?.username;
  }

  static fromURLParams(urlParams: URLSearchParams): SearchTransfersRequest {
    const request = new SearchTransfersRequest();
    request.estado = urlParams.get('estado') as EstadoTransferencia;
    request.from = urlParams.get('from') ? new Date(urlParams.get('from')) : null;
    request.to = urlParams.get('to') ? new Date(urlParams.get('to')) : null;
    request.cuentaOrigen = Number.parseInt(urlParams.get('cuentaOrigen')) || null;
    request.cuentaDestino = Number.parseInt(urlParams.get('cuentaDestino')) || null;
    request.username = urlParams.get('username') || '';
    return request;
  }

  setFromDate(date: Date) {
    const aDate = new Date(date);
    aDate.setUTCHours(0, 0, 0, 0);
    this.from = aDate;
  }

  setToDate(date: Date) {
    const aDate = new Date(date);
    aDate.setUTCHours(23, 59, 59, 999);
    this.to = aDate;
  }

  getFromDateString(): string {
    return this.from.toISOString();
  }

  getToDateString(): string {
    return this.to.toISOString();
  }
}
